/**
 * 生成limit范围内的随机整数
 * @param {number} limit
 */
export function randomNum (limit = 100) {
  return Math.floor(Math.random() * limit)
}

/**
 * 过滤掉对象中指定值的属性
 * @param {object} obj
 * @param {string} val
 */
export function filterProps (obj, val) {
  let keys = Object.keys(obj)
  let result = {}
  keys.forEach(key => {
    if (obj[key] !== val) {
      result[key] = obj[key]
    }
  })
  return result
}

/**
 * 验证手机号码：1开头的11位数字
 * @param {string} val
 */
export function validatePhoneNumber (val) {
  let reg = /^1[0-9]{10}$/g
  if (reg.test(val)) {
    return true
  } else {
    return false
  }
}

export default {
  randomNum
}



// WEBPACK FOOTER //
// ./src/utils/index.js